/**
 * Copyright Mántum All Rights Reserved.
 */
type PropTypes = {
    active?: boolean;
    children?: React.ReactNode;
    color?: string | null;
    disabled?: boolean;
    onClick?: () => void;
    testid?: string;
    title?: string;
    type?: 'fat' | 'simple';
};

export default function Text(props: PropTypes) {
    // prettier-ignore
    const { 
        active = false, 
        disabled = false, 
        type = 'simple' 
    } = props;

    const cursor = disabled ? 'cursor-default' : 'cursor-pointer';
    const background = active ? 'bg-primary text-accent' : '';

    const hover =
        !active && !disabled ? 'hover:text-black hover:bg-gray-200' : '';
    const height = type === 'simple' ? 'h-10' : 'h-14 text-lg';

    const className = `${cursor} ${background} ${hover} ${height}`;

    const style =
        !active && props.color
            ? {
                  backgroundColor: props.color,
                  color: '#fff'
              }
            : undefined;

    return (
        <button
            className={`inline-flex min-w-14 max-w-min items-center justify-center truncate rounded-md border border-transparent bg-accent px-4 py-2 text-base font-medium outline-offset-2 outline-accent-dark ${className}`}
            data-testid={props.testid}
            disabled={disabled}
            style={style}
            onClick={props.onClick}
            title={props.title}
            type='button'
        >
            {props.children}
        </button>
    );
}
